var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask120",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5344 13.225C14.3781 12.325 14.8 11.2469 14.8 9.99063C14.8 8.99687 14.5234 8.09688 13.9703 7.29063C13.4172 6.48437 12.6906 5.90313 11.7906 5.54688V5.8C11.7906 6.11875 11.6688 6.39531 11.425 6.62969C11.1812 6.86406 10.9 6.98125 10.5813 6.98125H9.4V8.19063C9.4 8.35938 9.33906 8.5 9.21719 8.6125C9.09531 8.725 8.95 8.78125 8.78125 8.78125H7.6V9.99063H11.2C11.3688 9.99063 11.5094 10.0469 11.6219 10.1594C11.7344 10.2719 11.7906 10.4125 11.7906 10.5813V12.3813H12.3812C12.9438 12.3813 13.3281 12.6625 13.5344 13.225ZM9.4 14.7437V13.5906C9.08125 13.5906 8.8 13.4688 8.55625 13.225C8.3125 12.9812 8.19062 12.7 8.19062 12.3812V11.7906L5.32188 8.92188C5.22812 9.29688 5.18125 9.65312 5.18125 9.99062C5.18125 11.2094 5.58906 12.2687 6.40469 13.1687C7.22032 14.0688 8.21874 14.5937 9.4 14.7437ZM5.74375 5.77188C6.92501 4.59062 8.34062 4 9.99062 4C11.6406 4 13.0516 4.58593 14.2234 5.75781C15.3953 6.92969 15.9812 8.34062 15.9812 9.99062C15.9812 11.6406 15.3953 13.0516 14.2234 14.2234C13.0516 15.3953 11.6406 15.9812 9.99062 15.9812C8.34062 15.9812 6.92969 15.3953 5.75781 14.2234C4.58593 13.0516 4 11.6406 4 9.99062C4 8.34062 4.58124 6.93438 5.74375 5.77188Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.7,
    y: -2.7,
    width: 23,
    height: 23.2,
    fill: "#2B2B2B",
    stroke: "#2B2B2B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.ec1df8262411659c981d13c1968139f0.svg";
export { ForwardRef as ReactComponent };